import { lazyPanes } from '@/lib/lazy-panes'

/** The job screen's panes, off the /jobs list chunk; the `$jobId` loader preloads them. */
export const jobDetail = lazyPanes(() => import('./job-detail-panes'))
